import WorkerApiService from "../../workerApiServices"

class NfseService extends WorkerApiService {

    constructor() {
        super('/api/nfse')
    }

    search(
        filtro,
        pageIndex,
        pageSize,
        sortField,
        sortDirection
    ){
        let params = `?`
        params = `${params}&page=${pageIndex}`
        params = `${params}&size=${pageSize}`
        params = `${params}&sort=${sortField},${sortDirection}`
        return this.post(`/search${params}`, filtro)
    }

    buscaFiltros(filtro){
        return this.post(`/buscaFiltros`, filtro)
    }

    searchByNumero(numero){
        let params = `?`
        params = `${params}&numero=${numero}`
        return this.get(`/searchByNumero${params}`)
    }


    validateNF(NFToValidate){
        return this.post(`/validateNF`, NFToValidate)
    }

    deleteNF(NFToDelete, gravarFrase){
        let params = `?`
        params = `${params}&gravarFrase=${gravarFrase}`
        return this.post(`/deleteNF${params}`, NFToDelete)
    }

    verificaInformacoesDelecao(nfId){
        let params = `?`
        params = `${params}&id=${nfId}`
        return this.get(`/verificaInformacoesDelecao${params}`)        
    }

    revalidarNF(NFToReativar){
        return this.post("/revalidarNF", NFToReativar)
    }    


}

export default NfseService